import * as React from 'react';
import { status } from '../constants';
import {abbreviationName} from '../../../../common/util';
import UserImage from '../../../../components/UserImage/index';
export default class MiscellaneousTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.renderTemplate = this.renderTemplate.bind(this);
    }

    renderTemplate(data, type) {
        switch (type) {
            case "TimeFrameUpdated":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        The time frame window for deleting notes has been updated
                       <label className="notification__time">{this.props.extraData.displayProfilePic ? this.props.data.CreatedDate.split("at")[1] : this.props.data.CreatedDate}</label>
                        </span>
                    </React.Fragment>
                );
            case "RequestToJoinOrg":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            {data.PendingUserName} would like to join your company <span className="bo"> {data.RecieverOrganizationName}</span>.
                        </span>
                    </React.Fragment>
                );
            case "GrantAccess":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">{`You now have access to Workkards & Activities of `}
                        <a href="javascript:void(0);" orgId={data.TriggeredByOrganizationId} onClick={(e)=>this.props.extraData.onProfileClick(e,data.TriggeredByOrganizationId,'org')}>{data.TriggeredByOrganisationName}</a>
                        </span>
                       <label className="notification__time">{this.props.extraData.displayProfilePic ? this.props.data.CreatedDate.split("at")[1] : this.props.data.CreatedDate}</label>
                    </React.Fragment>
                );
            case "ShareWorkkards":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">{`You have been granted view only access to specific `}
                            <a href={`/orgworkkardsview?id=${data.TriggeredByOrganizationId}`}>Workkards</a>{` by `}
                            <a href="javascript:void(0);" className="org-tooltip" orgId={data.TriggeredByOrganizationId} onClick={(e)=>this.props.extraData.onProfileClick(e,data.TriggeredByOrganizationId,'org')}>{data.TriggeredByOrganisationName}</a>
                        </span>
                       <label className="notification__time">{this.props.extraData.displayProfilePic ? this.props.data.CreatedDate.split("at")[1] : this.props.data.CreatedDate}</label>
                    </React.Fragment>
                );
            case "FeatureUpdate":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">{data.ActivityUpdateTemplate}</span>
                        <label className="notification__time">{data.CreatedDate.split("at")[1]}<a releaseVersion={data.ReleaseVersion} au={data.Id} id="featureExploreLink" className="fr cp">See more...</a></label>
                    </React.Fragment>
                );
            case "WorkloadShift":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            Workload of <a href={data.OldTargetUserProfile} title={data.OldTargetFullName}>{data.OldTargetFullName}</a> has been transferred to <a href={data.TargetUserProfile} title={data.TargetUserFullName}>{data.TargetUserFullName}.</a>
                        </span>
                       <label className="notification__time">{this.props.extraData.displayProfilePic ? this.props.data.CreatedDate.split("at")[1] : this.props.data.CreatedDate}</label>
                    </React.Fragment>
                );

            case "DeAssociateB2B":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                            <a href="javascript:void(0);" className="org-tooltip" orgId={data.B2BOrgId} onClick={(e)=>this.props.extraData.onProfileClick(e,data.B2BOrgId,'org')}>{data.B2BOrganisationName}</a> has been de-associated and Impacting your <a href="/ruleengine">#{data.RuleCount} Rule(s)</a>. Affected Rules would not be working now for this organization.
                        </span>
                       <label className="notification__time">{this.props.extraData.displayProfilePic ? this.props.data.CreatedDate.split("at")[1] : this.props.data.CreatedDate}</label>
                    </React.Fragment>
                );
            case "RuleException":
                return (
                    <React.Fragment>
                        <input type="hidden" value={data.Id} />
                        <span className="welcome_txt">
                        Rule - <a href={data.RuleUrl} title={data.RuleUrl}>{data.RuleName}</a> has created Diaries/Activities for blocked users.
                        </span>
                       <label className="notification__time">{this.props.extraData.displayProfilePic ? this.props.data.CreatedDate.split("at")[1] : this.props.data.CreatedDate}</label>
                    </React.Fragment>
                );
        }
    }

    render() {
        const {extraData}=this.props;
        return (
            <div className={extraData.displayMarkReadIcon ? (`card ${extraData.IsGroupByEnabled  && !extraData.showGroupedNotificationDetail ? 'cardGroup' :'cardPlain'} ${this.props.data.Status == status.read ? 'cardGroupRead' : ''}`):''} onClick={()=>{(extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail) ? this.props.handleCardClick(this.props.data) :false}}>
                {
                    extraData.displayMarkReadIcon && 
                    <React.Fragment>
                        {
                            <span className="posRight quickTooltip-bottom" data-quicktooltip={this.props.data.Status == status.read ? "mark as unread": "mark as read"} 
                            onClick={(e)=>{
                                e.stopPropagation();
                                        if(this.props.data.Status == status.read)
                                            extraData.handleMarkRead(this.props.data,status.unRead)
                                        else
                                            extraData.handleMarkRead(this.props.data,status.read)
                                        }}>
                                <em className={`read ${this.props.data.Status == status.read ? "unread":""}`}></em>
                            </span>
                        }
                        {extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail?<div className="rwoFlex alignMiddle wkNumber">
                            <label className="badges wkSymbol mr__1">{this.props.data.WorkkardId?'W':'0'}</label> {this.props.data.WorkkardNo?this.props.data.WorkkardNo:'Others'}
                            {
                                extraData.IsGroupByEnabled && extraData.GroupNotificationCounter > 0 && <label className="newCard ml__1">{extraData.GroupNotificationCounter > 99 ? '99+' : extraData.GroupNotificationCounter} new{extraData.RecentWorkkardCountRecieved && <span className="newCardNotification"></span>}</label>
                            }
                        </div> : this.props.data.AllNotificationCount > 0 ? <div className="rwoFlex alignMiddle"><label className="newCard">new</label></div> : null} 
                    </React.Fragment>
                }
                <div className={extraData.displayProfilePic ? "rowFlex mt activity_desc":"rowFlex activity_desc"}>
                    {
                        extraData.displayProfilePic && 
                        <div className="badges badgesSmall mr"> 
                         <UserImage profileUrl={this.props.data.TriggeredByProfileImage} size="22" className="profilePic" profileName={this.props.data.TriggeredByFullName}/>
                        
                        </div>
                    }
                    <div className={extraData.displayProfilePic ?"":"notificationDate"}>  
                        {
                            extraData.displayTriggerByName && 
                            <>
                                <span className="userName flexGrow" onClick={(e)=>extraData.onProfileClick(e,this.props.data.TriggeredById,'user')}>{this.props.data.TriggeredByFullName}</span>
                                {extraData.showGroupedNotificationDetail && <label>{abbreviationName(this.props.data.TriggeredByOrganisationNameFull)}</label>}
                            </>
                        }                                
                        {this.renderTemplate(this.props.data, this.props.type)}
                    </div>
                </div>
            </div>
        );
    }
}